var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "section-container section-home section-loading",
      staticStyle: { "flex-direction": "column" },
    },
    [
      _c("div", [_vm._v(_vm._s(_vm.$t("ui.not_found")))]),
      _c("section", { staticClass: "section border-bottom-section" }, [
        _c("div", { staticClass: "section-content" }, [
          _c("div", { staticClass: "columns is-centered is-vcentered" }, [
            _c("div", { staticClass: "column" }, [
              _c(
                "p",
                { staticClass: "subtitle has-text-centered" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "button is-primary",
                      attrs: { to: _vm.urlHome },
                    },
                    [_vm._v(_vm._s(_vm.$t("button.back_home")))]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }